// Abas do módulo — fonte única de título/subtítulo do head v2 (padrão
// crmRoutes, CANONICAL §2 Passo 0). O nav-bar filtra por feature flag
// (Bem-vindo condicional + FINANCIAL_PLANNING_SIMULATOR nas demais).
export const fpRoutes = () => [
  { name: 'fp.welcome', title: 'Bem-vindo' },
  {
    name: 'fp.home',
    title: 'Visão Geral',
    subtitle: 'Panorama do planejamento do cliente',
  },
  {
    name: 'fp.transacoes',
    title: 'Transações',
    subtitle: 'Orçamentos e transações do cliente',
  },
  {
    name: 'fp.objetivos',
    title: 'Objetivos',
    subtitle: 'Objetivos financeiros e alocações',
  },
  {
    name: 'fp.simulacoes',
    title: 'Simulações',
    subtitle: 'Planejamento patrimonial e cenário fiscal',
  },
  {
    name: 'fp.laboratorio',
    title: 'Laboratório',
    subtitle: 'Simule cenários sem salvar nada',
  },
  {
    name: 'fp.contas',
    title: 'Contas',
    subtitle: 'Conexões Open Finance e contas do cliente',
  },
  {
    name: 'fp.relatorios',
    title: 'Relatórios',
    subtitle: 'Monte e gere o relatório do cliente',
  },
]

export const PGBL_TYPE_OPTIONS = [
  { text: 'Dedução', value: 'deducao' },
  { text: 'Renda', value: 'renda' },
]

export const PGBL_MONTHS = [
  { label: 'Janeiro', value: '01' },
  { label: 'Fevereiro', value: '02' },
  { label: 'Março', value: '03' },
  { label: 'Abril', value: '04' },
  { label: 'Maio', value: '05' },
  { label: 'Junho', value: '06' },
  { label: 'Julho', value: '07' },
  { label: 'Agosto', value: '08' },
  { label: 'Setembro', value: '09' },
  { label: 'Outubro', value: '10' },
  { label: 'Novembro', value: '11' },
  { label: 'Dezembro', value: '12' },
]

export const PGBL_TAXABLE_TYPES = ['salários', 'férias', 'outras_receitas']

export const DEFAULT_TRIBUTACAO = 'ajuste_anual'

export const MONTH_DAY_REFERENCE = '01'

export const PGBL_TIPO_LABELS = {
  salários: 'Salário (R$)',
  férias: 'Férias (R$)',
  imposto_retido: 'IR Retido (R$)',
  inss: 'INSS (R$)',
  dependente: 'Dependentes (Qtd.)',
  contribuicoes_pgbl: 'PGBL Aplicado (R$)',
  outras_deducoes: 'Outras Deduções (R$)',
  outras_receitas: 'Outras Receitas (R$)',
  lazer: 'Lazer (R$)',
}

export const PGBL_HEADER_TO_TIPO = {
  valor_bruto: 'salários',
  ferias: 'férias',
  ir_retido: 'imposto_retido',
  inss: 'inss',
  dependente: 'dependente',
  pgbl_aplicado: 'contribuicoes_pgbl',
  outras_deducoes: 'outras_deducoes',
  outras_receitas: 'outras_receitas',
}

export const FIXED_HEADERS = [
  { text: 'Mês', value: 'month', sortable: false },
  { text: 'Salário (R$)', value: 'salários', sortable: false, numeric: true },
  {
    text: 'IR Retido (R$)',
    value: 'imposto_retido',
    sortable: false,
    numeric: true,
  },
  { text: 'Férias (R$)', value: 'férias', sortable: false, numeric: true },
  { text: 'INSS (R$)', value: 'inss', sortable: false, numeric: true },
  {
    text: 'Dependentes (Qtd.)',
    value: 'dependente',
    sortable: false,
    numeric: true,
  },
  {
    text: 'PGBL Aplicado (R$)',
    value: 'contribuicoes_pgbl',
    sortable: false,
    numeric: true,
  },
  {
    text: 'Outras Deduções (R$)',
    value: 'outras_deducoes',
    sortable: false,
    numeric: true,
    // editable: false,
  },
  {
    text: 'Outras Receitas (R$)',
    value: 'outras_receitas',
    sortable: false,
    numeric: true,
    // editable: false,
  },
]

